/**
 * Class to manage javascript cookies
 * @module Cookies
 */
 export default class Cookies {
    /**
     * Set the cookie
     * @param {String} cname - The name of the cookie
     * @param {String} cvalue - The value of the cookie
     * @param {integer} exdays - The days which the cookie will expire in milliseconds
     * @param {String} cpath - The path of the cookie
     * @method
     */
    static Set(cname, cvalue, exdays, cpath = "", samesite = "Lax") {
        var d = new Date();
        d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
        var expires = "expires=" + d.toUTCString();
        var secure = samesite == "None" ? " Secure" : "";
        cpath = cpath != null ? cpath : "";
        document.cookie = `${cname}=${cvalue}; ${expires}; path=/${cpath}; SameSite=${samesite};${secure}`;
    }

    /**
     * Get the cookie value
     * @param {String} cname - The name of the cookie
     * @method
     */
    static Get(cname) {
        var name = cname + "=";
        var ca = document.cookie.split(';');
        for (var i = 0; i < ca.length; i++) {
            var c = ca[i];
            while (c.charAt(0) == ' ') c = c.substring(1);
            if (c.indexOf(name) == 0) return c.substring(name.length, c.length);
        }
        return null;
    }

    /**
     * Delete the cookie
     * @param {String} cname - The name of the cookie
     * @param {String} cpath - The path of the cookie
     * @method
     */
    static Delete(cname, cpath) {
        if (cpath == null)
            cpath = "";
        Cookies.Set(cname, "", -1, cpath);
    }
}
